import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IUnit } from "../../units/iUnit";
import { IProduct } from "../iProduct";
import { ProductEditorViewModel, ProductInserter, ProductUpdater } from "../productEditor/productEditor-viewModel";
import  { ProductManipulationView } from "./productManipulation-view"

export class ProductManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تعریف کالا';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.products = ObservableArray.create<product>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),30);
        this.refresh()

    }
    GetDefaultView(): View <ViewModel> {
        return new ProductManipulationView();
    }
    public getTypeId(): string {
        return "VM-3D1691A9-DB79-4F48-B6B9-706239E4D472"
    }

    public set products(v: ObservableArray<product>) { this._products = v; } public get products(): ObservableArray<product> { return this._products;} private _products: ObservableArray<product>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/GetAllSimpleProducts',{
                FurtherQueryInfo:filteringInformation
            });
            this.products.update(...result.Products.map(q=>{
                let r = new product(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                r.groupId = q.GroupId;
                r.groupName = q.GroupName;
                r.unitIds = q.MeasuredProducts.map(x=>x.UnitId)
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new ProductEditorViewModel(this,new ProductInserter());
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
    async edit(product:product){
        let popup = new ProductEditorViewModel(this,new ProductUpdater());
        product.cloneTo(popup);
        let result = await this.showPopup(popup);
        if(result!=null){
            this.refresh();
        }
    }
}


export class product extends ViewModel implements IProduct{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ProductManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.unitIds = [];
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set unitIds(v: string[]) { this._unitIds = v; } public get unitIds(): string[] { return this._unitIds;} private _unitIds: string[];
    public set groupId(v: string) { this._groupId = v; } public get groupId(): string { return this._groupId;} private _groupId: string;
    public set groupName(v: string) { this._groupName = v; } public get groupName(): string { return this._groupName;} private _groupName: string;
    
    
    private _typedParent : ProductManipulationViewModel;

    setProductGroupId(id:string){
        this.groupId = id;
    }
    getProductGroupId():string{
        return this.groupId;
    }

    cloneTo(product: IProduct) {
        product.id = this.id;
        product.name = this.name;
        product.code = this.code;
        product.setUnitIds(this.getUnitIds());
        product.setProductGroupId(this.groupId);
    }
    edit(){
        this._typedParent.edit(this);
    }

    setUnitIds(value: string[]) {
        this.unitIds = value;
    }
    getUnitIds(): string[] {
        return this.unitIds;
    }
    
}

export class unit extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}